import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { writeHistory } from '@lib/core/service/slices';
import { useTypedDispatch } from '@lib/tools/views/hooks';

/**
 * ! Needs improvement
 * ? Move into Launcher
 * * Set the history object and its properties to be used outside React.
 */
export const history = {
  navigate: null,
  push: (page, ...args) => {
    if (history.navigate) history.navigate(page, ...args);
  },
};

export const Navigator = () => {
  const dispatch = useTypedDispatch();
  const location = useLocation();
  const navigateMethod = useNavigate();

  useEffect(() => {
    history.navigate = navigateMethod;
  }, []);

  useEffect(() => {
    dispatch(writeHistory(`${location.pathname}${location.search}`));
  }, [location]);

  return null;
};
